import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './components/ProtectedRoute';
import { RealtimeBridge } from './components/RealtimeBridge';
import { LoginPage } from './pages/LoginPage';
import { InvitePage } from './pages/InvitePage';
import { RegisterPage } from './pages/RegisterPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { VerifyEmailPage } from './pages/VerifyEmailPage';
import { DashboardPage } from './pages/DashboardPage';
import { MyRoomsPage } from './pages/MyRoomsPage';
import { RoomPage } from './pages/RoomPage';
import { ManageRoomPage } from './pages/ManageRoomPage';
import { CreateRoomPage } from './pages/CreateRoomPage';
import { CalendarPage } from './pages/CalendarPage';
import { BetPage } from './pages/BetPage';
import { ProfilePage } from './pages/ProfilePage';
import { AdminMatchesPage } from './pages/AdminMatchesPage';
import { AdminEditMatchPage } from './pages/AdminEditMatchPage';
import { AdminUsersPage } from './pages/AdminUsersPage';
import { AdminRoomsPage } from './pages/AdminRoomsPage';
import { AdminInvitationsPage } from './pages/AdminInvitationsPage';

export function App() {
  return (
    <>
      <RealtimeBridge />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
      <Route path="/invite/:code" element={<InvitePage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
      <Route path="/verify-email/:token" element={<VerifyEmailPage />} />

      <Route
        path="/"
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/rooms"
        element={
          <ProtectedRoute>
            <MyRoomsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/rooms/new"
        element={
          <ProtectedRoute>
            <CreateRoomPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/rooms/:id"
        element={
          <ProtectedRoute>
            <RoomPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/rooms/:id/manage"
        element={
          <ProtectedRoute>
            <ManageRoomPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/calendar"
        element={
          <ProtectedRoute>
            <CalendarPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/bet/:matchId"
        element={
          <ProtectedRoute>
            <BetPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <ProfilePage />
          </ProtectedRoute>
        }
      />
      <Route path="/admin" element={<Navigate to="/admin/matches" replace />} />
      <Route
        path="/admin/matches"
        element={
          <ProtectedRoute requireAdmin>
            <AdminMatchesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/matches/:id"
        element={
          <ProtectedRoute requireAdmin>
            <AdminEditMatchPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/users"
        element={
          <ProtectedRoute requireAdmin>
            <AdminUsersPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/rooms"
        element={
          <ProtectedRoute requireAdmin>
            <AdminRoomsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/invitations"
        element={
          <ProtectedRoute requireAdmin>
            <AdminInvitationsPage />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
